var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.106509 0.81L10.1716 13.683C10.2396 13.77 10.2781 13.881 10.2781 13.992V26.499C10.2781 26.775 10.497 26.997 10.7692 26.997C10.8669 26.997 10.9615 26.967 11.0414 26.913L15.497 23.916C15.6331 23.823 15.716 23.667 15.716 23.499V13.989C15.716 13.875 15.7544 13.767 15.8225 13.68L25.8935 0.81C26.0621 0.594 26.0266 0.279 25.8136 0.108C25.7249 0.039 25.6183 0 25.5059 0H0.491124C0.218935 0 0 0.222 0 0.498C0 0.612 0.0384615 0.72 0.106509 0.81Z","fill":"currentColor"}));
}

Filter.defaultProps = {"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none"};

module.exports = Filter;

Filter.default = Filter;
